import image191100AudienceWide from './image-191-100-audience-wide';
import image178100EdgeSingle from './image-178-100-edge-single';
import image178100BingDesktop from './image-178-100-bing-desktop';
import image172100EdgeMedium from './image-172-100-edge-medium';
import image169100MSNSingle from './image-169-100-msn-single';
import image155100MSNMedium from './image-155-100-msn-medium';
import image150100MSNInArticle from './image-150-100-msn-in-article';
import image133100MSNSmall from './image-133-100-msn-small';
import image11AudienceSquare from './image-1-1-audience-square';
import image093100MSNDouble from './image-093-100-msn-double';


export const imageExtensionTemplates = [
  image191100AudienceWide,
  image178100EdgeSingle,
  image178100BingDesktop,
  image172100EdgeMedium,
  image169100MSNSingle,
  image155100MSNMedium,
  image150100MSNInArticle,
  image133100MSNSmall,
  image11AudienceSquare,
  image093100MSNDouble,
];
